import React from 'react';

import Box from '@mui/material/Box';

interface Props {}

const AxisSelectForm = React.forwardRef<
    HTMLDivElement,
    React.PropsWithChildren<Props>
>((props, ref) => {
    const firstChild = React.Children.toArray(props.children).at(0);
    const lastChild = React.Children.toArray(props.children).at(-1);
    return (
        <Box
            sx={{ position: 'absolute', zIndex: 10, width: '100%', ml: -1 }}
            display="flex"
        >
            {firstChild}
            <Box ref={ref} flexGrow={1}></Box>
            {lastChild}
        </Box>
    );
});

AxisSelectForm.displayName = 'AxisSelectForm';

export default AxisSelectForm;
